import { useAtomValue, useSetAtom } from "jotai";
import { useCallback, useEffect } from "react";

import {
  closureWeeksAtom,
  dirtyAtom,
  loadClosureWeeksAtom,
  overrunAtom,
  saveClosureWeeksAtom,
} from "../stores/closureWeeks";

export type UseClosureWeeksOptions = {
  projectId: number;
  year: number;
  onSaved?: (year: number) => void;
  onCancel?: () => void;
};

export type UseClosureWeeks = {
  loading: boolean;
  saving: boolean;
  dirty: boolean;
  overrun: boolean;
  save: () => Promise<void>;
  cancel: () => void;
};

export function useClosureWeeks({
  projectId,
  year,
  onSaved,
  onCancel,
}: UseClosureWeeksOptions): UseClosureWeeks {
  const { loading, saving } = useAtomValue(closureWeeksAtom);
  const dirty = useAtomValue(dirtyAtom);
  const overrun = useAtomValue(overrunAtom);

  const load = useSetAtom(loadClosureWeeksAtom);
  const saveWeeks = useSetAtom(saveClosureWeeksAtom);

  useEffect(() => {
    void load(projectId, year);
  }, [load, projectId, year]);

  const save = useCallback(async () => {
    if (await saveWeeks()) {
      onSaved?.(year);
    }
  }, [saveWeeks, onSaved, year]);

  const cancel = useCallback(() => onCancel?.(), [onCancel]);

  return { loading, saving, dirty, overrun, save, cancel };
}
